import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';

const Review = ({checkoutToken}) => {

  console.log(checkoutToken)

  return (
    <>
    <h6>Order Summary</h6>
    <ListGroup>
    {checkoutToken.line_items.map((product)=>(
         <ListGroup.Item key={product.name}>
            {product.name} x {product.quantity} = {product.line_total.formatted_with_symbol}
         </ListGroup.Item>
    ))}
    <ListGroup.Item>
        <h6>Total: {checkoutToken.subtotal.formatted_with_symbol}</h6>
    </ListGroup.Item>
    </ListGroup>
    </>
  )
}

export default Review
